import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";

const Columns = ({ permissions, user }) => [
  {
    dataField: "module",
    text: "Module",
    formatter: (_, row) => <span className="text">{row.module}</span>,
  },
  {
    dataField: "action",
    text: "Action",
    formatter: (_, row) => <span className="text">{row.action}</span>,
  },
  {
    dataField: "permissionKey",
    text: "Permission Key",
    formatter: (_, row) => <span className="text">{row.permissionKey}</span>,
  },
  {
    dataField: "adminName",
    text: "Admin Name",
    formatter: (_, row) => <span className="text">{row.adminDetails?.name || user?.name}</span>,
  },
  {
    text: "Created At",
    dataField: "date_created_utc",
    formatter: (_, row) => row.createdAt && DATE_FORMAT(row.createdAt),
  }
];
export default Columns;
